<template>
  <div>
    <table
      class="table is-hoverable is-striped-v is-fullwidth is-first-fixed-xsmall is-marginless-bottom"
      v-if="contacts && contacts.length">
      <thead>
        <tr class="is-size-6">
          <th>Statut</th>
          <th>Date de création</th>
          <th>Nom</th>
          <th>Prénom</th>
          <th>
            Email
          </th>
          <th>
            Téléphone
          </th>
          <th>
            Ville
          </th>
          <th>Origine</th>
        </tr>
      </thead>
      <tbody>
        <tr
          class="is-border-top is-size-6"
          v-for="(contact, index) in contacts"
          :key="'tr' + index">
          <td class="has-text-centered">
            <span
              class="dot tooltip is-tooltip-right"
              :style="{'background-color': tagColor(contact.status)}"
              :data-tooltip="contact.status | contactStatusLabel" />
          </td>
          <td>
            <span>
              {{ contact.created_on | dtFormat('DD/MM/YYYY HH:mm') }}
            </span>
          </td>
          <td class="is-cell-hoverable">
            <router-link
              :to="{name: 'ContactVue', params: {id: contact.pk}}">
              {{ contact.last_name }}
            </router-link>
          </td>
          <td class="is-cell-hoverable">
            <router-link
              :to="{name: 'ContactVue', params: {id: contact.pk}}">
              {{ contact.first_name }}
            </router-link>
          </td>
          <td class="is-cell-hoverable">
            <router-link
              v-if="contact.email"
              :to="{name: 'ContactVue', params: {id: contact.pk}}">
              {{ contact.email }}
            </router-link>
            <span v-else>-</span>
          </td>
          <td
            class="is-cell-hoverable">
            <router-link
              v-if="contact.phone"
              :to="{name: 'ContactVue', params: {id: contact.pk}}">
              {{ contact.phone }}
            </router-link>
            <span v-else>-</span>
          </td>
          <td>
            <span v-if="contact.address && (contact.address.city || contact.address.zip_code)">
              {{ contact.address.city || '-' }} <span v-if="contact.address.zip_code">({{ contact.address.zip_code }})</span>
            </span>
            <span v-else>-</span>
          </td>
          <td>
            <span v-if="contact.origin">
              {{ contact.origin.name }}
            </span>
            <span v-else>-</span>
          </td>
        </tr>
      </tbody>
    </table>
    <div
      class="is-padding"
      v-else>
      Aucun contact à afficher
    </div>
    <pagination
      :loading="loading"
      :current-page="currentPage"
      :total-page="totalPage"
      @changePage="loadItems($event)"></pagination>
  </div>
</template>

<script>
import DefaultValues from '@/mixins/DefaultValues.js'
import { mapGetters, mapState } from 'vuex'
import randomColor from 'randomcolor'

export default {
  name: 'ContactsLightList',
  mixins: [DefaultValues],
  props: {
    loading: {
      type: Boolean
    },
    currentPage: {
      type: Number
    },
    totalPage: {
      type: Number
    },
    totalContact: {
      type: Number
    },
    contacts: {
      type: Array,
      require: true
    }
  },
  computed: {
    ...mapState(['currentUser']),
    ...mapGetters(['isAdmin', 'isPromoteur']),
    currentView () {
      return this.$route.name
    }
  },
  methods: {
    loadItems (event) {
      this.$emit('loadItems', event)
    },
    tagColor (value, hue = 'blue') {
      let color = randomColor({
        seed: value,
        hue
      })
      return color
    }
  }
}
</script>
